/** Risk level → Tailwind color maps used across all pages */
export const RISK_LEVEL_COLORS: Record<string, { badge: string; text: string; bg: string }> = {
  'منخفض': {
    badge: 'risk-badge-low',
    text:  'text-green-700 dark:text-green-400',
    bg:    'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800',
  },
  'متوسط': {
    badge: 'risk-badge-med',
    text:  'text-yellow-700 dark:text-yellow-400',
    bg:    'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800',
  },
  'عالي': {
    badge: 'risk-badge-high',
    text:  'text-orange-700 dark:text-orange-400',
    bg:    'bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-800',
  },
  'مرتفع': {
    badge: 'risk-badge-high',
    text:  'text-orange-700 dark:text-orange-400',
    bg:    'bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-800',
  },
  'حرج': {
    badge: 'risk-badge-crit',
    text:  'text-red-700 dark:text-red-400',
    bg:    'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800',
  },
};

/** Compute SLA status for a given incident */
export function formatSlaTime(
  createdAt: string,
  slaMinutes: number,
  status: string
): { remaining: string; breached: boolean } | null {
  const closed = ['مغلق', 'RCA Completed'];
  if (closed.includes(status)) return null;

  const elapsed  = (Date.now() - new Date(createdAt).getTime()) / 60_000;
  const remaining = slaMinutes - elapsed;

  if (remaining <= 0) {
    const over = Math.abs(remaining);
    return { remaining: formatMinutes(over) + ' فائت', breached: true };
  }
  return { remaining: formatMinutes(remaining), breached: false };
}

function formatMinutes(minutes: number): string {
  if (minutes < 60) return `${Math.round(minutes)} د`;
  const hours = Math.floor(minutes / 60);
  const mins  = Math.round(minutes % 60);
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    return `${days} ي`;
  }
  return mins > 0 ? `${hours} س ${mins} د` : `${hours} س`;
}

/** Format a date string to Arabic locale */
export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('ar-SA', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/** Truncate long text */
export function truncate(text: string, maxLength = 80): string {
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}

/** Generate initials from a full Arabic name */
export function getInitials(name: string): string {
  return name.trim().split(' ').slice(0, 2).map(w => w[0]).join('');
}
